import {
	Component,
	Input,
	OnInit,
	Output,
	EventEmitter,
	OnDestroy,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { TranslateService } from '@mangosoft/mango-layout';
import { Subscription } from 'rxjs';
import { DataPagination } from '../../../Domain/Adapters';


@Component({
	selector: 'app-pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit, OnChanges, OnDestroy {
	@Output() private emitNavigationPag: EventEmitter<number> = new EventEmitter();
	public textTo: any;
	@Input() info: DataPagination = {
		page: 0,
		pageTo: 0,
		total: 0,
	} as DataPagination;
	private subscriptionTranslate!: Subscription;

	constructor(private translateService: TranslateService) {}

	ngOnInit(): void {
		this.getTranslate();
	}

	ngOnChanges(changes: SimpleChanges): void {

	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.textTo = data.components.pagination.to;
		});
	}

	back() {
		if (this.info.pages > 1) {
			if (this.info.previous) {
				this.emitNavigation(this.info.previous);
			} else {
				this.emitNavigation(this.info.pages);
			}
		}
	}

	fullNext() {
		if (this.info.pages > 1) {
			if (this.info.next) {
				this.emitNavigation(this.info.pages);
			}
		}
	}

	fullBack() {
		if (this.info.pages > 1) {
			if (this.info.previous) {
				this.emitNavigation(1);
			}
		}
	}

	next() {
		if (this.info.pages > 1) {
			if (this.info.next) {
				this.emitNavigation(this.info.next);
			} else {
				this.emitNavigation(1);
			}
		}
	}

	emitNavigation(numberPage: number) {
		this.emitNavigationPag.emit(numberPage);
	}

	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
